import { Modal } from "components";
import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { Message } from "semantic-ui-react";

interface Props {
  isOpen: boolean
  onClose: () => void
}

const MaxMySelectionCountModal = (props: Props) => {
  return <Modal
    isOpen={props.isOpen}
    handleClose={props.onClose}
    title={RESX.GeneralLabels.MySelection}
  >
    <Message color="red">
      {RESX.GeneralWarnings.TheMaximumHasBeenReached.replace("{0}", serverReference.constants.mySelection.maxItemsInMySelection.toString())}
    </Message>
    <div className="flex justify-end">
      <div>
        <ButtonPrimary onClick={props.onClose} label={RESX.Buttons.BtnOk} />
      </div>
    </div>
  </Modal>;
};

export default MaxMySelectionCountModal;
